import { api } from "./instance";
import {
  Client,
  CompaniesSearch,
  CompaniesTable,
  DataUpdate,
  FolderData,
  FolderTable,
} from "@/redux/clients/types/Clients.interface";

const _clientService = {
  getCompanies: async () => {
    const response = await api.get<Client[]>(`/client`);
    return response.data;
  },
  getDataCompanies: async () => {
    const response = await api.get<CompaniesTable[]>(`/client/get-data`);
    return response.data;
  },
  getFolders: async (clienteId: string) => {
    const response = await api.get<FolderTable>(`/client/${clienteId}`);
    return response.data;
  },
  getFolderData: async (folderId: string) => {
    const response = await api.get<FolderData>(`/client/folder/${folderId}`);
    return response.data;
  },
  getCompaniesSearch: async () => {
    const response = await api.get<CompaniesSearch[]>(`/client/search-input`);
    return response.data;
  },
  getDataUpdates: async () => {
    const response = await api.get<DataUpdate[]>(`/client/data-updates`);
    return response.data;
  },
  updateDb: async () => {
    const response = await api.get(`/client/update-db`);
    return response.data;
  },
};

export default _clientService;
